import axios from "axios";
import config from "../../config"

export default {
  namespaced: true,
  state: {
    allPrefectures: null,
    allGrades: null,
    allSubjects: [],
    allPeriods: null,
    allMaterials: null,
    allMaterialKinds: null,
    allQuestionTypes: null,
    allAnswerFormats: null,
    allDifficulties: null,
    allPoints: null,
    allSchools: null,
    allAthleticEvents: null,
    allCities: null,
  },

  getters: {
    subjectBases: state => {
      return state.allSubjects
        .filter(subject => {
          return subject.ancestry === null
        })
    },
    subjectRoot: state => subject_id => {
      const subject = state.allSubjects.find(x => x.id == subject_id)
      return subject.ancestry ? state.allSubjects.find(x => x.id == subject.ancestry) : subject
    },
    difficultyStandard: state => {
      return state.allDifficulties.find(difficulty => difficulty.code === config.difficulties.STANDARD)
    },
  },

  mutations: {
    setAllPrefectures(state, payload) {
      state.allPrefectures = payload.allPrefectures;
    },
    setAllGrades(state, payload) {
      state.allGrades = payload.allGrades;
    },
    setAllSubjects(state, payload) {
      // 教科マスタの内容を格納
      state.allSubjects = payload.allSubjects
    },

    setAllPeriods(state, payload) {
      state.allPeriods = payload.allPeriods;
    },
    setAllMaterials(state, payload) {
      state.allMaterials = payload.allMaterials;
    },
    setAllMaterialKinds(state, payload) {
      state.allMaterialKinds = payload.allMaterialKinds;
    },
    setAllQuestionTypes(state, payload) {
      state.allQuestionTypes = payload.allQuestionTypes;
    },
    setAllAnswerFormats(state, payload) {
      state.allAnswerFormats = payload.allAnswerFormats;
    },
    setAllDifficulties(state, payload) {
      state.allDifficulties = payload.allDifficulties;
    },
    setAllPoints(state, payload) {
      state.allPoints = payload.allPoints;
    },
    setAllSchools(state, payload) {
      state.allSchools = payload;
    },
    setAllAthleticEvents(state, payload) {
      state.allAthleticEvents = payload.allAthleticEvents;
    },
    setAllCities(state, payload) {
      state.allCities = payload.allCities;
    },
  },

  actions: {
    //マスタデータ取得
    async getMasterData(store) {
      const api = axios.create()
      // 並列処理を行う
      await axios.all([
        api.get('/api/v1/prefectures'),
        api.get('/api/v1/grades'),
        api.get('/api/v1/subjects'),
        api.get('/api/v1/periods'),
        api.get('/api/v1/materials'),
        api.get('/api/v1/question_types'),
        api.get('/api/v1/answer_formats'),
        api.get('/api/v1/difficulties'),
        api.get('/api/v1/points'),
        api.get('/api/v1/athletic_events'),
        api.get('/api/v1/cities'),
      ]).then( axios.spread( (res1, res2, res3, res4, res5, res6, res7, res8, res9, res10, res11) => {
        // 各種マスタ情報をstoreに格納

        store.commit('setAllPrefectures', {allPrefectures: res1.data })
        store.commit('setAllGrades', {allGrades: res2.data })

        // キャメルケースに変換
        const allSubjects = res3.data.map( subject => {
          let camelObj = {
            id:            subject.id,
            code:          subject.code,
            name:          subject.name,
            ancestry:      subject.ancestry,
            ancestryDepth: subject.ancestry_depth,
            shortName:     subject.short_name,
          }
          // ログイン中のアカウントがteacherの場合のみ、教科書マスタの内容を格納
          const storageData = JSON.parse(sessionStorage.getItem('ShingakushaEpro'));
          if(storageData.user.role === 'Teacher' ) {
            camelObj.publishers = subject.publishers
          }
          return camelObj
        })
        store.commit('setAllSubjects',      {allSubjects:      allSubjects })

        store.commit('setAllPeriods',       {allPeriods:       res4.data })
        store.commit('setAllMaterials',     {allMaterials:     res5.data })
        store.commit('setAllMaterialKinds', {allMaterialKinds: config.materialKinds })
        store.commit('setAllQuestionTypes', {allQuestionTypes: res6.data })
        store.commit('setAllAnswerFormats', {allAnswerFormats: res7.data })
        store.commit('setAllDifficulties',  {allDifficulties:  res8.data })
        store.commit('setAllPoints',        {allPoints:        res9.data })
        store.commit('setAllAthleticEvents', {allAthleticEvents: res10.data })
        store.commit('setAllCities', {allCities: res11.data })
      }))
    },
  },
}
